<template>
    <form ref="form" class="flex flex-col items-stretch">

        <!-- Kundendaten
        <div class="border mt-8 bg-white">
            <div class="border-b p-4">
                <field :col="true" :title="$t('customer-information.title')" :description="$t('customer-information.description')"></field>
            </div>
            <div class="bg-white p-4">
                <field v-if="form.kundentyp" :title="$t('customer-information.customer-type.company-name')">
                    <input type="text" v-model="form.companyname" class="w-1/2">
                </field>
                <field :title="$t('customer-information.customer-type.customer-code')" class="mt-4">
                    <input type="text" v-model="form.kundennummer" class="w-1/2">
                </field>
            </div>

            <div class="p-4 pt-0">
                <field :title="$t('customer-information.contact-person.address.name')">
                    <input type="text" name="name" v-model="form.anschrift.name" class="w-1/2">
                </field>
                <field :title="$t('customer-information.contact-person.address.street')" class="mt-4">
                    <input type="address" v-model="form.anschrift.straße" class="w-1/2">
                </field>
                <field :title="$t('customer-information.contact-person.address.postcode')" class="mt-4">
                    <input type="text" name="postalcode" v-model="form.anschrift.postleitzahl" class="w-1/2">
                </field>
                <field :title="$t('customer-information.contact-person.address.city')" class="mt-4">
                    <input type="text" name="city" v-model="form.anschrift.city" class="w-1/2">
                </field>
            </div>

            <div class="p-4 pt-0">
                <field :title="$t('customer-information.contact-person.contact.mail') + ' *'">
                    <input type="email" v-model="form.mail" class="w-1/2" @change="form.mailCopyTo.splice(0, 1, $event.target.value);" required>
                </field>
                <field :title="$t('customer-information.contact-person.contact.phone')" class="mt-4">
                  <input type="tel" v-model="form.telephone" class="w-1/2">
                </field>
            </div>
        </div>
        -->

        <!-- Email receivers -->
        <div class="border mt-8 bg-white">
          <div class="border-b p-4">
            <field :col="true" :title="$t('customer-information.send-configuration.title')" :description="$t('customer-information.send-configuration.description')"></field>
          </div>
          <div class="m-4">
              <field
                  :title="$t('customer-information.send-configuration.receiver-email')">
                <input type="email" v-model="form.mailCopyTo[i-1]" class="w-1/2" autocomplete="off">
              </field>
          </div>
        </div>

        <!-- Confirm data privacy -->
        <div class="border mt-8 bg-white">
            <div class="border-b p-4">
                <field :col="true" :title="$t('summary.data-privacy.title')"></field>
            </div>
            <div class="m-4">
                <div class="flex">
                    <input type="checkbox" name="" class="m-4" id="data-privacy" required>
                    <label for="data-privacy" v-html="$t('summary.data-privacy.text')">
                        <!-- text-blue-600 -->
                        <!-- summary.data-privacy.text -->
                    </label>
                </div>
                
            </div>
        </div>


<!--        <div class="border mt-8 bg-white">-->
<!--            <div class="border-b p-4 font-bold">-->
<!--                {{ $t('customer-information.comments') }}-->
<!--            </div>-->
<!--            <div class="p-4">-->
<!--                <textarea rows="10" v-model="form.anmerkungen" class="w-full"></textarea>-->
<!--            </div>-->
<!--        </div>-->

        <warning v-if="send_error" :title="$t('notifications.send-failed.title')" class="mt-8">
            {{ $t('notifications.send-failed.body') }}
        </warning>

        <div class="flex flex-row-reverse items-start justify-between mt-8">
            <div @click="send" class="bg-primary text-white px-4 py-2 flex flex-row items-center uppercase font-bold tracking-wide cursor-pointer select-none">
                <loader v-if="sending" class="h-4 w-4 mr-2"></loader>
                {{ $t('commons.submit') }}
            </div>
            <div @click="$router.push({ name: 'configure' })" class="bg-white text-gray-600 px-4 py-2 flex flex-row items-center uppercase font-bold tracking-wide cursor-pointer select-none">
                <div class="border-b-2 border-l-2 border-primary h-2 w-2 mr-2" :style="{ transform: 'rotate(45deg)' }"></div>
                {{ $t('commons.back') }}
            </div>
        </div>
    </form>
</template>

<script>
import Field from '@/components/Field'
import Chooser from '@/components/Chooser'
import Warning from '@/components/Warning'
import Loader from '@/components/Loader'
import options from '@/assets/js/options'

export default {
    components: { Field, Chooser, Warning, Loader },
    props: {
        form: Object,
    },
    data: () => ({
        options,
        sending: false,
        send_error: false,
    }),
    methods: {
        async send() {
            if(!this.$refs.form.reportValidity()) {
                return false;
            }
            this.sending = true
            try {
                await this.form.send()
                this.save_found = false
                this.send_error = false
                this.$router.push({ name: 'done' })
            } catch(error) {
                console.error(error)
                this.sendFailed()
            } finally {
                this.sending = false
            }
        },
        sendFailed() {
            this.send_error = true
        },
    },
    created() {
        if(this.form.kundentyp === null) {
            this.form.kundentyp = this.options.kundentyp[0].name;
        }
    }
}
</script>

<style lang="stylus">
    .hiddeninput
        height 5px
        width 5px
        padding 0
        margin 0
        overflow hidden
</style>